import React from 'react';
import { observer } from 'mobx-react';
import { ESignPreferenceListTemplate } from 'themes/application/esign-preference/pages';
import { setCurrentView } from 'core/utils';
import { ESignPreferenceListViewStore } from 'application/esign-preference/stores';

@setCurrentView((rootStore) => new ESignPreferenceListViewStore(rootStore), 'eSignPreferenceListViewStore')
@observer
class ESignPreferenceList extends React.Component {
    render() {
        return <ESignPreferenceListTemplate {...this.props} />
    }
}

export default ESignPreferenceList;